/* src/app/shared/modal-dialog/confirm/confirm.component.scss */
body#themeTag :host ::ng-deep .mat-dialog-actions {
  display: flex;
  flex-direction: row-reverse;
}
body#themeTag :host ::ng-deep .p-dialog-title .button-bar {
  padding: 0;
}
body#themeTag :host ::ng-deep .p-toolbar {
  justify-content: space-between;
}
body#themeTag :host ::ng-deep .p-toolbar > * {
  flex-grow: 1;
  flex-shrink: 1;
}
body#themeTag :host ::ng-deep .p-dialog-footer {
  padding: 0 0 1em 0;
}
body#themeTag :host ::ng-deep .dialog-text {
  padding-bottom: 1em;
  text-align: justify;
}
/*# sourceMappingURL=confirm.component.css.map */
